import { Box } from 'components/ui';
import { mapToCollectionFilterItems } from 'utils/futura';
import { CollectionAttributes, CollectionFilterItem } from 'utils/types';
import CollectionFilter from './CollectionFilter';

interface CollectionFiltersProps {
  collectionStats: Array<CollectionAttributes>;
  checked: string[];
  onAttributeChecked: (name: string, checked: string[]) => void;
}

const CollectionFilters = ({
  collectionStats,
  checked,
  onAttributeChecked, 
}: CollectionFiltersProps) => {
  // This set will be used to render all possible collection filter items, both hierarchical or flat.
  let collectionFilterItems = mapToCollectionFilterItems(collectionStats);

  return (
    <Box height="100%">
      {collectionFilterItems.map((collectionFilterItem: CollectionFilterItem) => (
        <CollectionFilter
          key={collectionFilterItem.name}
          checked={checked}
          handleCheck={onAttributeChecked}
          item={collectionFilterItem}
        ></CollectionFilter>
      ))}
    </Box>
  );
};

export default CollectionFilters;
